import { combineReducers, createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { type AccountConfigurationInfo, type AccountType } from "../../../types";
import type Role from "../../../../../interfaces/role";
import type { GlobalRole } from "interfaces/role";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "features/Application/slices/createFetchingItemsSlice";
import {
  fetchAccountTypes,
  accountTypesPrefixPayload,
  fetchGlobalRoles,
  fetchChildAccountRoles,
  globalRolesStatePrefixPayload,
  childRolesStatePrefixPayload,
} from "../thunks/createAccountThunk";

const accountTypesState: FetchingItemsState<AccountType> = {
  items: [],
  itemsCount: 0,
  isLoading: false,
};

const accountTypesSlice = createFetchingItemsSlice({
  namePayload: accountTypesPrefixPayload,
  initialState: accountTypesState,
  reducers: {},
  thunk: fetchAccountTypes,
});

const globalRolesState: FetchingItemsState<GlobalRole> = {
  items: [],
  itemsCount: 0,
  isLoading: false,
};

const childRolesState: FetchingItemsState<Role> = {
  items: [],
  itemsCount: 0,
  isLoading: false,
};

const globalRolesSlice = createFetchingItemsSlice({
  namePayload: globalRolesStatePrefixPayload,
  initialState: globalRolesState,
  reducers: {},
  thunk: fetchGlobalRoles,
});

const childRolesSlice = createFetchingItemsSlice({
  namePayload: childRolesStatePrefixPayload,
  initialState: childRolesState,
  reducers: {},
  thunk: fetchChildAccountRoles,
});

const initialState: AccountConfigurationInfo = {
  accountTypeId: 0,
  alias: null,
  contractTypeId: null,
  isDemo: false,
  logoUri: null,
  landscapeLogoUri: null,
  magicLinkLogin: false,
  name: "",
  parentAccountId: null,
  sessionTimeoutDays: 0,
  sessionTimeoutHours: 0,
  sessionTimeoutMinutes: 0,
  id: 0,
  accountTypeName: "",
  dateModified: "",
  parentName: "",
  canEdit: false,
  canChangeAccountType: false,
  tags: [],
  parentAccountTypeId: null,
  readonlyTags: [],
};

const configurationSlice = createSlice({
  name: "configuration",
  initialState,
  reducers: {
    setAccountCreateConfiguration: (_, action: PayloadAction<AccountConfigurationInfo>) => {
      return action.payload;
    },
    resetAccountConfiguration: () => {
      return initialState;
    },
  },
});

export const { setAccountCreateConfiguration, resetAccountConfiguration } = configurationSlice.actions;

const createAccountReducer = combineReducers({
  accountTypes: accountTypesSlice.reducer,
  globalRoles: globalRolesSlice.reducer,
  childRoles: childRolesSlice.reducer,
  configuration: configurationSlice.reducer,
});

export default createAccountReducer;
